import { ApolloSandbox } from '@apollo/sandbox/react';

const GraphqlSandbox = () => {
  return (
    <div>
      <ApolloSandbox
        initialEndpoint={`${window.location.origin}/graphql`}
        initialState={{
          includeCookies: true,
          pollForSchemaUpdates: false,
          sharedHeaders: {
            Authorization: 'Basic dGltdGFzQHlhaG9vLmNvbTpsZXRtZWlu' // timtas@yahoo.com
          //   Authorization: 'Basic amRvb3JAZXhhbXBsZS5jb206bGV0bWVpbg==' // jdoor@example.com
          }
        }}
        hideCookieToggle={false}
        sx={{
          height: '100vh',
        }}
      />
    </div>
  );
}

export default GraphqlSandbox;
